












































































































































































































































import Vue, { PropType } from 'vue';
import { ActionMethod, mapActions } from 'vuex';
import { startCase } from 'lodash';

import { get } from 'vuex-pathify';
import { DataTableHeader } from 'vuetify';

import { Module } from '@/models/configurator/module';
import { QuoteProductItem, Quote, QuoteProductCategory } from '@/models/quote';
import {
  ConfigurationItem,
  IConfigurationItem,
  IConfigurationItemData
} from '@/models/configurator/configuration';
import { CurrencyRate } from '@/models/currency';
import { IQuoteProductItem } from '@/models';
import { roundCurrency } from '@/utils/helpers';

export default Vue.extend({
  name: 'QuoteSummaryDetailList',
  props: {
    quote: { type: Object as PropType<Quote> }
  },

  data: () => ({
    confiruationItemsMap: {} as any,
    quoteDetailSummaryLoading: false,

    configurationItemsHeaders: [
      {
        text: '',
        value: 'icons',
        sortable: false,
        width: 90
      },
      {
        text: 'Items',
        align: 'start',
        sortable: false,
        value: 'item',
        width: 210,
        class: 'item-name-column'
      },
      {
        text: 'Description',
        value: 'description',
        // width: 260,
        sortable: false
      },
      {
        text: 'Unit Price',
        value: 'unit_price',
        align: 'start',
        sortable: false,
        // width: 120,
        class: 'unit-price-column'
      },
      {
        text: 'Unit Discount',
        value: 'unit_discount',
        align: 'start',
        sortable: false,
        // width: 120,
        class: 'discount-column'
      },

      {
        text: 'Unit Net Price',
        value: 'unit_net_price',
        align: 'start',
        sortable: false,
        // width: 120,
        class: 'unit-price-column'
      },

      {
        text: 'Quantity',
        value: 'quantity',
        align: 'center',
        sortable: false,
        // width: 70,
        class: 'quantity-column'
      },

      { text: 'U/M', value: 'unit', sortable: false, width: 65 },

      {
        text: 'Total Price',
        value: 'net_price',
        align: 'end',
        sortable: false,
        width: 170,
        class: 'total-price-column'
      },

      {
        text: 'Tariff Rate',
        value: 'tariff_rate',
        align: 'center',
        sortable: false,
        width: 100
      },

      {
        text: '',
        value: '',
        sortable: false,
        width: 10
      }
    ] as DataTableHeader[]
  }),

  computed: {
    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),

    getCurrencyById: get<(id: number) => CurrencyRate>(
      'currency/getCurrencyById'
    )
  },
  methods: {
    startCase,
    roundCurrency,

    ...mapActions({
      fetchQuoteConfigurationItems: 'quote/fetchQuoteConfigurationItems'
    }),

    itemDetailClass(item: IConfigurationItem) {
      if (item.is_obsolete) {
        return 'item-row--disabled';
      }
    },

    async fetchQuoteCategoryItems(
      quoteProductCategory: QuoteProductCategory
    ): Promise<ConfigurationItem[]> {
      return this.fetchQuoteConfigurationItems({
        id: this.quote.number!,
        revision: this.quote.revision,
        quoteProductCategory: quoteProductCategory.id!,
        language: this.quote.language
      }).then((items: IConfigurationItemData[]) => {
        return items.map(item => new ConfigurationItem(item));
      });
    },

    configurationPriceTotal(products: QuoteProductItem[]): number {
      const list: ConfigurationItem[] = [];
      products.forEach(product => {
        list.push(...this.confiruationItemsMap[product.configuration!]);
      });

      return list.reduce(
        (acc, cur) =>
          acc +
          (roundCurrency(cur.unit_price! * this.quote.exchange_rate!) -
            roundCurrency(cur.unit_discount! * this.quote.exchange_rate!)) *
            cur.quantity!,
        0
      );
    },

    init() {
      this.quoteDetailSummaryLoading = true;
      this.quote.categories.forEach((category: any, index: number) => {
        this.fetchQuoteCategoryItems(category)
          .then((items: ConfigurationItem[]) => {
            category.products?.forEach((product: IQuoteProductItem) => {
              const configuration = product.configuration!;
              Vue.set(
                this.confiruationItemsMap,
                configuration,
                items.filter(item => item.configuration == configuration)
              );
            });
          })
          .finally(() => {
            this.quoteDetailSummaryLoading = false;
          });
      });
    }
  },

  watch: {
    quote: function() {
      // Using watcher to update configurable
      // items whenever the quote changes
      this.init();
    }
  },

  mounted() {
    this.init();
  }
});
